import React, { useContext, useEffect, useState } from 'react';
import { CourseDesignContext } from '../context/CourseDesignContext';
import { getESTDateString } from '../utils/serverFetchAndAddUtilities';


const HandBackAssignments = () => {
  const { courseDesignState, handleChange } = useContext(CourseDesignContext);
  const [localEvaluations, setLocalEvaluations] = useState([]);

  useEffect(() => {
    const filteredEvaluations = courseDesignState
      .filter(item => item.dataType === 'evaluation')
      .sort((a, b) => a.questionCourseDate.localeCompare(b.questionCourseDate));
    setLocalEvaluations(filteredEvaluations);
  }, [courseDesignState]);

  const handleGradingStatusChange = (dataID, newStatus) => {
    // Update the local state for immediate feedback
    setLocalEvaluations(prevEvaluations =>
      prevEvaluations.map(evaluation =>
        evaluation.dataID === dataID
          ? { ...evaluation, questionLogic: newStatus }
          : evaluation
      )
    );

    // Persist the change in the database
    const updatedEvaluation = localEvaluations.find(
      evaluation => evaluation.dataID === dataID
    );
    if (updatedEvaluation) {
      handleChange('evaluation', dataID, updatedEvaluation.dataText, {
        questionLogic: newStatus,
      });
    }
  };

  const handleEditDueDate = (dataID, newDate) => {
  // Update local state with the new due date
  setLocalEvaluations(prev =>
    prev.map(evaluation =>
      evaluation.dataID === dataID
        ? { ...evaluation, questionCourseDate: newDate }
        : evaluation
    )
  );

  // Persist the change in the database
  const updatedEvaluation = localEvaluations.find(
    evaluation => evaluation.dataID === dataID
  );
  if (updatedEvaluation) {
    handleChange('evaluation', dataID, updatedEvaluation.dataText, {
      questionCourseDate: newDate,
    });
  }
};

  // Warning modal state for editing past-due dates
  const [showDueDateWarning, setShowDueDateWarning] = useState(false);
  const [pendingDueDateEvalId, setPendingDueDateEvalId] = useState(null);

  const isPastDate = (yyyyMmDd) => {
    if (!yyyyMmDd) return false;
    const todayStr = getESTDateString(Date.now());
    return yyyyMmDd < todayStr;
  };

  const requestEditDueDate = (evaluation) => {
    // If the current due date is in the past, show warning modal
    if (isPastDate(evaluation.questionCourseDate)) {
      setPendingDueDateEvalId(evaluation.dataID);
      setShowDueDateWarning(true);
      return;
    }
    // Else proceed directly
    const newDate = prompt(
      'Enter a new due date (yyyy-mm-dd):',
      evaluation.questionCourseDate
    );
    if (newDate) handleEditDueDate(evaluation.dataID, newDate);
  };

  const confirmProceedEditDueDate = () => {
    const evaluation = localEvaluations.find(e => e.dataID === pendingDueDateEvalId);
    setShowDueDateWarning(false);
    setPendingDueDateEvalId(null);
    if (!evaluation) return;
    const newDate = prompt(
      'Enter a new due date (yyyy-mm-dd):',
      evaluation.questionCourseDate
    );
    if (newDate) handleEditDueDate(evaluation.dataID, newDate);
  };

  const formatDate = (dateString) => {
  if (!dateString) return 'No due date set';

  const [year, month, day] = dateString.split('-');
  const months = [
    'January', 'February', 'March', 'April', 'May',
    'June', 'July', 'August', 'September', 'October',
    'November', 'December'
  ];
  return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}, ${year}`;
};

  // Lightweight tooltip button component
  const TooltipButton = ({ tooltip, children, style, ...buttonProps }) => {
    const [show, setShow] = useState(false);
    return (
      <div style={{ position: 'relative', display: 'inline-block' }}
           onMouseEnter={() => setShow(true)}
           onMouseLeave={() => setShow(false)}>
        <button style={style} {...buttonProps}>{children}</button>
        {show && (
          <div style={{
            position: 'absolute',
            bottom: '110%',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '6px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            maxWidth: '260px',
            textAlign: 'left',
            boxShadow: 'var(--standard-box-shadow)',
            zIndex: 100
          }}>
            {tooltip}
            <div style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '6px solid rgba(0,0,0,0.8)'
            }} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="hand-back-assignments">
      <div className="instructions">
        <p>You can use the buttons below to make grades and comments available to students. Once "grading complete" is selected, students will be able to view their grades and comments for that assignment. You can also edit due dates for assignments below; but be aware that changing the due date of an assignment delete all numerical grades for that assignment. (This is because changing the due date will also change which student answers are being evaluated.) You can give extensions to individual students by clicking "custom due date" on the page for that student's assignment.</p>
      </div>

      {localEvaluations.map(evaluation => (
        <div
          key={evaluation.dataID}
          className="evaluation-item"
          style={{
            backgroundColor: 'white',
            boxShadow: 'var(--standard-box-shadow)',
            padding: '16px',
            marginBottom: '16px',
          }}
        >
          <h2>{evaluation.dataText}</h2>
                 <p>Due Date: {formatDate(evaluation.questionCourseDate)}</p>


        <button
          onClick={() => requestEditDueDate(evaluation)}
        >
          Edit Due Date
        </button>

          <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
            <TooltipButton
              tooltip={"No students can view comments or grades on this assignment."}
              style={{
                backgroundColor:
                  evaluation.questionLogic === 'ungraded' ? 'var(--color3)' : 'white',
                color: 'black',
                boxShadow: 'var(--standard-box-shadow)',
                padding: '8px 16px',
                cursor: 'pointer',
                border: 'none',
                borderRadius: '4px',
              }}
              onClick={() => handleGradingStatusChange(evaluation.dataID, 'ungraded')}
            >
              No grades handed back
            </TooltipButton>
            <TooltipButton
              tooltip={"All students can view comments or grades on this assignment, even if that grading is still incomplete."}
              style={{
                backgroundColor:
                  evaluation.questionLogic === 'graded' ? 'var(--color3)' : 'white',
                color: 'black',
                boxShadow: 'var(--standard-box-shadow)',
                padding: '8px 16px',
                cursor: 'pointer',
                border: 'none',
                borderRadius: '4px',
              }}
              onClick={() => handleGradingStatusChange(evaluation.dataID, 'graded')}
            >
              All grades handed back
            </TooltipButton>
            <TooltipButton
              tooltip={"All students whose grades are complete can view comments or grades on this assignment. (In courses with oral exams, this will exclude students whose oral exams are incomplete.)"}
              style={{
                backgroundColor:
                  evaluation.questionLogic === 'gradedCompletedOnly' ? 'var(--color3)' : 'white',
                color: 'black',
                boxShadow: 'var(--standard-box-shadow)',
                padding: '8px 16px',
                cursor: 'pointer',
                border: 'none',
                borderRadius: '4px',
              }}
              onClick={() => handleGradingStatusChange(evaluation.dataID, 'gradedCompletedOnly')}
            >
              All completed grades handed back
            </TooltipButton>
          </div>
        </div>
      ))}
      {showDueDateWarning && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white', padding: '20px', borderRadius: '8px',
            maxWidth: '720px', width: '90%', boxShadow: 'var(--standard-box-shadow)',
            fontFamily: 'var(--font-secondary)'
          }}>
            <div style={{ whiteSpace: 'pre-wrap', marginBottom: '16px' }}>
              {`Changing the due date of an assignment will delete all numerical grades for that assignment. (This is because changing the due date will also change which student answers are being evaluated, given that students may have added work in the interim.) You can give extensions to individual students by clicking "custom due date" on the page for that student's assignment. Would you like to change the due date, and delete all numerical grades for the assignment?`}
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => { setShowDueDateWarning(false); setPendingDueDateEvalId(null); }}
                style={{ backgroundColor: 'var(--color1)', color: 'white', border: 'none', borderRadius: 4, padding: '8px 12px', cursor: 'pointer' }}
              >
                No
              </button>
              <button
                onClick={confirmProceedEditDueDate}
                style={{ backgroundColor: 'var(--color1)', color: 'white', border: 'none', borderRadius: 4, padding: '8px 12px', cursor: 'pointer' }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HandBackAssignments;
